module.exports = __webpack_public_path__ + "img/swf.45b17a6d.png";